export default "__VITE_ASSET__3de64930__"